import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavStatIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 2.25H2C1.04 2.25 0.25 3.04 0.25 4V20C0.25 20.96 1.04 21.75 2 21.75H22C22.96 21.75 23.75 20.96 23.75 20V4C23.75 3.04 22.96 2.25 22 2.25ZM22.25 20C22.25 20.14 22.14 20.25 22 20.25H2C1.86 20.25 1.75 20.14 1.75 20V4C1.75 3.86 1.86 3.75 2 3.75H22C22.14 3.75 22.25 3.86 22.25 4V20Z"
        fill={color}
      />
      <path
        d="M19.78 7.10003H16.22C15.88 7.10003 15.6 7.38003 15.6 7.72003C15.6 8.06003 15.88 8.34003 16.22 8.34003H18.27L12.25 14.36L9.19 11.3C8.95 11.06 8.55 11.06 8.31001 11.3L3.31 16.3C3.07 16.54 3.07 16.94 3.31 17.18C3.55 17.42 3.95 17.42 4.19 17.18L8.75 12.62L11.81 15.68C12.05 15.92 12.45 15.92 12.69 15.68L19.15 9.22003V11.27C19.15 11.62 19.43 11.89 19.77 11.89C20.11 11.89 20.39 11.61 20.39 11.27V7.71003C20.39 7.36003 20.11 7.09003 19.77 7.09003L19.78 7.10003Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavStatIcon.displayName = 'NavStatIcon';
